import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';

@invoke
export class Sorter {
  static Instance: Sorter;

  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'select-sort-option',
          callback: this.onSortOptionClick,
        },
      ],
    });
  }

  onSortOptionClick(e) {
    e.preventDefault();

    let target = e?.target as HTMLElement;
    const parent = target?.parentElement?.parentElement;

    if (parent && target) {
      const optionValue = target.attributes['data-value']?.value;
      const optionText = target.querySelector("[data-container='sort-option-text']")?.innerHTML;
      const selectedElement = parent.querySelector("[data-container='selected-sort-option']") as HTMLElement;

      if (selectedElement) {
        selectedElement.innerHTML = optionText;
        selectedElement.dataset['value'] = optionValue;
      }

      parent.removeAttribute('open');
      parent.classList.remove('open');

      const customEvent = selectedElement?.attributes['data-custom-event']?.value;

      if (customEvent) {
        const event = new Event(customEvent, { bubbles: true, cancelable: true });
        selectedElement?.dispatchEvent(event);
      }
    }

    return false;
  }
}
